var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"navigation-mobile"}},[_vm._l((_vm.tabs),function(item){return _c('ul',{key:item.path,attrs:{"to":item.path,"active-class":""},on:{"click":function($event){return _vm.$router.push(item.path)}}},[_c('li',[_vm._v(_vm._s(item.name))])])}),_c('dark-mode')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }